import { render, staticRenderFns } from "./ContractorShow.vue?vue&type=template&id=22c8afec&scoped=true&"
import script from "./ContractorShow.vue?vue&type=script&lang=js&"
export * from "./ContractorShow.vue?vue&type=script&lang=js&"
import style0 from "./ContractorShow.vue?vue&type=style&index=0&id=22c8afec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c8afec",
  null
  
)

export default component.exports